import React, { Component } from "react";
import PropTypes from "prop-types";
import { graphql } from "react-apollo";
import { queryGetOnlineStatus } from "Apollo";
import Picker from "module-common/Picker";

export default graphql(queryGetOnlineStatus)(
  class PickerStatus extends Component {
    static propTypes = { onSelected: PropTypes.func };
    render() {
      const data = this.props.data;
      const statuses = data.getOnlineStatusType;
      const options = [];
      if (statuses) {
        statuses.forEach(status => {
          status.name !== "offline" &&
            options.push({
              label: status.displayName,
              value: status
            });
        });
      }
      return (
        <Picker {...this.props} options={options}>
          {this.props.children}
        </Picker>
      );
    }
  }
);



// WEBPACK FOOTER //
// ./src/module-sidemenu/online-status/PickerStatusWithQuery.js